import WebService from "./WebService";
class EntityRatingService extends WebService {
  getEntityRatings(pageInfo, sortInfo, callback, failureCallback) {
    const urlParams = this.urlFactory.constructPaginationAndFilteringUrlQueries(
      pageInfo,
      sortInfo
    );
    const url = this.urlFactory.entityRatings() + urlParams;
    return this.get(url, callback, undefined, failureCallback);
  }

  postEntityRating(
    entityRating,
    callback,
    successCallback = undefined,
    failureCallback
  ) {
    const url = this.urlFactory.entityRatings();
    return this.post(
      url,
      entityRating,
      callback,
      successCallback,
      failureCallback
    );
  }
}
export default EntityRatingService;
